<script>
  import Layout from "@/components/pages/layouts/vertical";
  import PageHeader from "@/components/page-header";
  import { mapState } from 'vuex';

  export default {
    name: 'OrderList',
    computed: {
      ...mapState("order", ["orders"]),
    },
    components: { Layout, PageHeader }
  }
</script>

<template>
  <Layout>
    <PageHeader />
    <div class="card">
      <div class="card-body">
        <div class="table-responsive">
          <table class="table mb-0">
            <thead>
              <tr>
                <th>#</th>
                <th>Code</th>
                <th>Status</th>
                <th>Date</th>
                <th class="text-sm-end">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(order, index) in this.orders" :key="index">
                <td>{{index+1}}</td>
                <td>
                  <router-link :to="`/orders/${order.id}`"
                    class="d-block text-primary text-decoration-underline mb-2">
                    {{order.wh_id}}
                  </router-link>
                </td>
                <td>{{order.status}}</td>
                <td>{{order.wh_date_created | formatDate}}</td>
                <td class="text-sm-end">$ {{order.total}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </Layout>
</template>
